<template>
  <div id="selectTool">
    <div id="text">
      <slot name="text"></slot>
    </div>
    <div class="selectToolItem" v-for="(x, index) in forms" :key="index">
      <div class="label">
        <Select v-if="x.select" v-model="item[x.keys]" style="width: 100px" :readonly="x.readonlys"
          :disabled="x.disableds" :filterable="true" :allow-create="x.allowCreates">
          <Option :value="x.selectTypes == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItemss" :key="index1"
            :label="x.selectTypes == 'obj' ? y.name : y">
            <span>{{ x.selectTypes == "obj" ? y.name : y }}</span>
          </Option>
        </Select>
        <p v-else>
          {{ x.title }}
        </p>
      </div>
      <Input v-if="x.type == 'Input'" v-model="item[x.key]" placeholder="请输入" :type="x.type1" :rows="x.rows"
        :readonly="x.readonly" :disabled="x.disabled" :clearable="true" :maxlength="x.maxlength"
        :show-word-limit="x.showWordLimit" style="width: 130px"></Input>
      <slot v-if="x.slotForm" :name="x.slotForm"></slot>
      <InputNumber v-if="x.type == 'InputNumber'" v-model="item[x.key]" :min="x.min" :max="x.max" :readonly="x.readonly"
        :disabled="x.disabled" :clearable="x.clearable" style="width: 130px"></InputNumber>
      <selectGroup :name="item[x.key1]" @update:name="item[x.key1] = $event" :id="item[x.key]"
        @update:id="item[x.key] = $event" v-if="x.type == 'selectGroup'" @name="item[x.key1] = $event"
        @groupIds="item[x.groupIds] = $event" @groupNames="item[x.groupNames] = $event" :more="x.more"></selectGroup>
      <RadioGroup v-model="item[x.key]" v-if="x.type == 'radio'">
        <Radio :label="x.selectType == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItems" :key="index1" border>{{
          x.selectType == "obj" ? y.name : y }}</Radio>
      </RadioGroup>
      <Select v-model="item[x.key]" :style="{ width: (x.width ? x.width : 150) + 'px' }" v-if="x.type == 'Select'"
        :multiple="x.multiple" :readonly="x.readonly" :disabled="x.disabled" :filterable="true"
        :allow-create="x.allowCreate" :max-tag-count="1" clearable @on-clear="item[x.key] = ''">
        <Option :value="x.selectType == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItems" :key="index1"
          :label="x.selectType == 'obj' ? y.name : y">
          <span>{{ x.selectType == "obj" ? y.name : y }}</span>
        </Option>
      </Select>
      <selectUser v-if="x.type == 'selectUser'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
        :account="item[x.key3]" @update:account="item[x.key3] = $event" :accountId="item[x.key4]"
        @update:accountId="item[x.key4] = $event" :id="item[x.key]" @update:id="item[x.key] = $event"
        @accountIds="item[x.accountIds] = $event" @accounts="item[x.accounts] = $event" @names="item[x.names] = $event"
        :keyword="x.keyword" :isHand="x.isHand" :clearable="x.clearable" :more="x.more">
      </selectUser>

      <selectCar v-if="x.type == 'selectCar'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
        :id="item[x.key]" @update:id="item[x.key] = $event">
      </selectCar>

      <selectPerson v-if="x.type == 'selectPerson'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
        :id="item[x.key]" @update:id="item[x.key] = $event" @deviceIdList="item[x.key] = $event" :isMore="x.isMore">
      </selectPerson>
      <selectDriver v-if="x.type == 'selectDriver'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
        :id="item[x.key]" @update:id="item[x.key] = $event" @driverIdList="item[x.key] = $event" :isMore="x.isMore">
      </selectDriver>
      <start-end ref="startEnd" @StartEndTime="$emit('StartEndTime',$event)" v-if="x.type == 'lyyymmdd'" :addDay="x.addDay?0:x.addDay" :timeModel="x.times"
        :datetime="x.formate"></start-end>
      <selectAlotGroup placement="left" v-if="x.type == 'selectGroups'" @groupIdList="item[x.key] = $event"
        :isMore="x.more" noAutoLoad></selectAlotGroup>
      <selecAlotCCar v-if="x.type == 'selectAlotCar'" @deviceIdList="item[x.key] = $event"
        @carIdList="item[x.carIdList] = $event"></selecAlotCCar>
      <selectAlotDevice v-if="x.type == 'selectAlotDevice'" @deviceIdList="item[x.key] = $event"></selectAlotDevice>
    </div>
    <slot name="item"></slot>
    <div class="selectToolItem">
      <slot name="btn"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      forms: [],
      item: {},
    };
  },
  methods: {
    reach(v, item) {
      this.forms = v;
      this.item = item;
      console.log('selectool筛选控件',item)
    },
    getItem() {
      if (this.$refs.startEnd) {
        this.item.startTime = this.$refs.startEnd[0].getTimeObj().start;
        this.item.endTime = this.$refs.startEnd[0].getTimeObj().end;
      }

      return this.item;
    },
  },
};
</script>
<style lang="">
#selectTool {
  background: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  padding: 6px 0px 0 0;
}
#selectTool #text {
  margin: 8px 10px;
}
#selectTool .selectToolItem {
  float: left;
  display: flex;
  margin-bottom: 10px;
}

#selectTool .label {
  margin-left: 10px;
  margin-right: 10px;
}
#selectTool .label > p {
  margin-top: 8px;
}
#selectTool button.chaxun {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/selectTool.vue